import React from 'react';
import T from 'prop-types';

const Logo = ({ logo, width, height, className }) => (
  <svg className={className} width={width} height={height}>
    <use xlinkHref={`#${logo.id}`} />
  </svg>
);

Logo.defaultProps = {
  width: 49,
  height: 42,
  className: '',
};

Logo.propTypes = {
  logo: T.shape({}).isRequired,
  width: T.number,
  height: T.number,
  className: T.string,
};

export default Logo;



// WEBPACK FOOTER //
// ../src/components/Logo/index.jsx